import Vue from 'vue';

import {Enum}      from '@/app/shared/enum/enum';
import UtilService from '@/app/shared/service/util.service';

const $util = new UtilService();

Vue.filter('enumCodeFilter', (value: string, obj: any, nullTag?: string) => {
  let valueNm = value;

  if (!!value && !!obj && !!obj['NAME_' + value]) {
    valueNm = obj['NAME_' + value];
  }

  if (!value && !!nullTag) {
    valueNm = nullTag;
  }

  return valueNm;
});

Vue.filter('dateFilter', (value: string) => {
  let valueNm = value;

  if (!!value) {
    valueNm = $util.dateToFormatDate(value);
  }

  return valueNm;
});

Vue.filter('countDownFilter', (value: number) => {
  let returnValue = '';

  if (!!value) {
    const second = value / Enum.CORE.TIMER.SECOND;
    returnValue = `${Math.floor(second / Enum.CORE.TIMER.MINUTE)}:${$util.setNumberToString(Math.floor(second % Enum.CORE.TIMER.MINUTE))}`;
  }

  return returnValue;
});
